// extracted by css-extract-rspack-plugin
export default {"separator":"sXW3Q"};